<docs>
# Kontrol
> A Tweakpane Control Panel to help by exposing and updating specific properties during the dev env

@author Guillaume Tomasi <guillaume@kffein.com>
</docs>

<script lang="ts" setup>
import { getEnv } from "config";
import { defineAsyncComponent } from 'vue';
  
const KONTROL_ENABLE = getEnv('VITE_KONTROLS');
const KontrolPanel = defineAsyncComponent(() => import(/* webpackChunkName: "kontrol-pannel" */'./Panel.vue'));
</script>
    
<template>
  <KontrolPanel v-if="KONTROL_ENABLE" />  
</template>
